import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaUserCheck, FaClock, FaFire } from 'react-icons/fa';

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);
  const [registeredCount, setRegisteredCount] = useState(67);
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 30
  });
  
  useEffect(() => {
    // Show floating CTA after 2 seconds
    const timer = setTimeout(() => {
      setVisible(true);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Countdown timer
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Simulate people registering
    const interval = setInterval(() => {
      setRegisteredCount(prev => {
        const increment = Math.floor(Math.random() * 3) + 1;
        return prev + increment <= 100 ? prev + increment : prev;
      });
    }, 30000); // Every 30 seconds

    return () => clearInterval(interval);
  }, []);
  
  return (
    <AnimatePresence>
      {visible && (
        <motion.div 
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 100, damping: 15 }}
          className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-darkGray via-darkerBlue to-darkGray py-3 md:py-4 px-4 shadow-[0_-10px_30px_rgba(212,175,55,0.2)] z-50 border-t border-primary/30"
        >
          <div className="container max-w-6xl mx-auto">
            {/* Mobile Layout */}
            <div className="block md:hidden">
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center text-xs">
                  <div className="flex items-center gap-1 text-primary">
                    <FaUserCheck />
                    <span className="font-bold">{registeredCount}/100</span> kursi terisi
                  </div>
                  <div className="flex items-center gap-1 text-red-400">
                    <FaClock />
                    <span className="font-bold">{String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                </div>
                <motion.a 
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  href="/checkout" 
                  className="bg-gradient-to-r from-primaryDark to-primary hover:from-primary hover:to-primaryLight text-darkBlue font-bold py-3 px-4 rounded-lg text-center text-sm shadow-lg"
                >
                  KLAIM DISKON 71% SEKARANG
                </motion.a>
              </div>
            </div>

            {/* Desktop Layout - Cleaner Design */}
            <div className="hidden md:flex items-center justify-center gap-8">
              <motion.div 
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="flex items-center gap-3 bg-red-500/20 px-4 py-2 rounded-full border border-red-500/30"
              >
                <FaFire className="text-red-400 text-lg" />
                <div className="text-center">
                  <div className="text-xs text-red-400 uppercase tracking-wider">Terbatas!</div>
                  <div className="font-bold text-white">{100 - registeredCount} Kursi Tersisa</div>
                </div>
              </motion.div>
              
              <div className="flex items-center gap-3 bg-darkGray/50 px-4 py-2 rounded-full">
                <FaClock className="text-primary text-lg" />
                <div>
                  <div className="text-xs text-textGray">Diskon Berakhir</div>
                  <div className="font-bold text-primary text-lg">
                    {String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
                  </div>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="text-center">
                  <div className="text-sm line-through opacity-60">Rp 350.000</div>
                  <div className="text-3xl font-bold text-primary">Rp 100.000</div>
                </div>
                
                <motion.a 
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  href="/checkout" 
                  className="bg-gradient-to-r from-primaryDark to-primary hover:from-primary hover:to-primaryLight text-darkBlue font-bold py-4 px-10 rounded-xl text-lg shadow-2xl relative overflow-hidden group"
                >
                  <span className="relative z-10">DAFTAR SEKARANG →</span>
                  <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity"></div>
                </motion.a>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;